import { combineReducers } from "redux";
import auth from "redux/auth/reducers";
import app from "redux/app/reducers";
import { CLEAN_STORE } from "redux/actions";
import ecommerce from "../app/reducers/ecommerce";

const appReducer = combineReducers({
  auth,
  app,
  ecommerce,
});

const rootReducer = (state, action) => {
  const newState = action.type === CLEAN_STORE ? undefined : state;

  return appReducer(newState, action);
};

export default rootReducer;
